export default {
  // async
  SET_CARD_GAME: 'SET_CARD_GAME',
  SET_CURRENT_GAME_REF: 'SET_CURRENT_GAME_REF',
  GET_SIMILAR: 'GET_SIMILAR',
  GAME_WRONG: 'GAME_WRONG',
  RESET_GAME: 'RESET_GAME',
  GET_MISTAKES: 'GET_MISTAKES',
  GET_CARD_COLOR: 'GET_CARD_COLOR',
  UPDATE_CARD_COLOR: 'UPDATE_CARD_COLOR',
  GET_HERO_COLOR: 'GET_HERO_COLOR',
  UPDATE_HERO_COLOR: 'UPDATE_HERO_COLOR',
};
